import { DefinitionList, IconButton } from '@cognitranlimited/itis-web';
import React, { useMemo } from 'react';
import './codeList.css';
import { vehicleCodesModuleApi } from './vehicleCodesModuleApi';
import { faCircleDown } from '@fortawesome/free-regular-svg-icons/faCircleDown';
function getCodeValue(title, getCode, code) {
    if (code === '') {
        return '-';
    }
    if (!code) {
        return React.createElement(IconButton, { icon: faCircleDown, title: title, onClick: getCode });
    }
    return code;
}
export var CodeList = function (_a) {
    var vin = _a.vin, context = _a.context;
    var vehicleCodes = context.strings.vehicleCodes;
    var _b = vehicleCodesModuleApi.useLazyGetVehicleIgnitionKeyCodeQuery(), triggerIgnitionKeyCode = _b[0], resultIgnitionKeyCode = _b[1];
    var _c = vehicleCodesModuleApi.useLazyGetVehicleRadioCodeQuery(), triggerRadioCode = _c[0], resultRadioCode = _c[1];
    var _d = vehicleCodesModuleApi.useLazyGetVehicleImmobilizerCodeQuery(), triggerImmobilizerCode = _d[0], resultImmobilizerCode = _d[1];
    var getIgnitionKeyCode = function () {
        triggerIgnitionKeyCode(vin);
    };
    var getRadioCode = function () {
        triggerRadioCode(vin);
    };
    var getImmobilizerCode = function () {
        triggerImmobilizerCode(vin);
    };
    var items = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        return [
            {
                name: vehicleCodes.ignitionKeyCode,
                value: getCodeValue("".concat(vehicleCodes.get, " ").concat(vehicleCodes.ignitionKeyCode), getIgnitionKeyCode, (_a = resultIgnitionKeyCode.data) === null || _a === void 0 ? void 0 : _a.ignitionKeyCode),
                copyToClipboard: !resultIgnitionKeyCode.isUninitialized && ((_b = resultIgnitionKeyCode.data) === null || _b === void 0 ? void 0 : _b.ignitionKeyCode) !== ''
            },
            {
                name: vehicleCodes.radioCode,
                value: getCodeValue("".concat(vehicleCodes.get, " ").concat(vehicleCodes.radioCode), getRadioCode, (_c = resultRadioCode.data) === null || _c === void 0 ? void 0 : _c.radioCode),
                copyToClipboard: !resultRadioCode.isUninitialized && ((_d = resultRadioCode.data) === null || _d === void 0 ? void 0 : _d.radioCode) !== ''
            },
            {
                name: vehicleCodes.immobiliserCode,
                value: getCodeValue("".concat(vehicleCodes.get, " ").concat(vehicleCodes.immobiliserCode), getImmobilizerCode, (_e = resultImmobilizerCode.data) === null || _e === void 0 ? void 0 : _e.immobilizerCode),
                copyToClipboard: !resultImmobilizerCode.isUninitialized && ((_f = resultImmobilizerCode.data) === null || _f === void 0 ? void 0 : _f.immobilizerCode) !== ''
            }
        ];
    }, [resultIgnitionKeyCode, resultRadioCode, resultImmobilizerCode]);
    return (React.createElement("div", { className: 'PanelGrid VehicleOverviewTab' },
        React.createElement("div", { className: 'PanelGrid-column' },
            React.createElement("section", { className: 'Panel VehicleInformationPanel' },
                React.createElement("div", { className: 'Panel-header' },
                    React.createElement("h3", null, vehicleCodes.title)),
                React.createElement("div", { className: 'Panel-content VehicleCodesModuleValue' },
                    React.createElement(DefinitionList, { definitions: items }))))));
};
